import { useTranslation } from "react-i18next";
import {
  RejectionReason,
  selectRejectedByReason,
  useAppSelector,
} from "../../../store";
import { Message } from "../";
import "./ValidationMessages.scss";

/**
 * Surfaces validation errors for the most recent file intake. Rendered on the
 * review step (the upload flow always advances there, even when some files are
 * rejected) so guests see what was skipped and can pick replacements from the
 * Select step via the add-more button.
 */
export const ValidationMessages = () => {
  const { t } = useTranslation();

  const unsupportedFiles = useAppSelector(
    selectRejectedByReason(RejectionReason.UNSUPPORTED_FORMAT),
  );
  const oversizedFiles = useAppSelector(
    selectRejectedByReason(RejectionReason.FILE_SIZE_TOO_BIG),
  );

  const groups = [
    {
      key: "unsupported",
      label: t("fileUpload.unsupportedFormat"),
      files: unsupportedFiles,
    },
    {
      key: "oversized",
      label: t("fileUpload.fileTooLarge"),
      files: oversizedFiles,
    },
  ].filter((group) => group.files.length > 0);

  if (groups.length === 0) return null;

  return (
    <Message variant="error" className="validation-message">
      <div className="validation-groups">
        {groups.map((group) => (
          <div key={group.key} className="validation-group">
            <h4>
              {group.label} (
              {t("common.fileCount", { count: group.files.length })})
            </h4>
            <p>{group.files.join(", ")}</p>
          </div>
        ))}
      </div>
    </Message>
  );
};
